import { registerPlugin } from '@capacitor/core';

export interface VideoTranscodeOptions {
  inputPath: string;
  maxLongEdge?: number;
  targetBitrate?: number;
}

export interface VideoTranscodeResult {
  outputPath: string;
  mimeType?: string;
}

export interface VideoTranscoderPlugin {
  transcodeVideo(options: VideoTranscodeOptions): Promise<VideoTranscodeResult>;
}

export const VideoTranscoder = registerPlugin<VideoTranscoderPlugin>('VideoTranscoder');
